import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import About from "../components/About";
import Services from "../components/Services";
import WhyUs from "../components/WhyUs";
import QuoteForm from "../components/QuoteForm";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <WhyUs />
        <QuoteForm />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
